import { Link } from '@tanstack/react-router';
import { useIntl } from 'react-intl';
import { Button, Logo } from '@caratuva/ui';
import { LanguageSwitcher } from './LanguageSwitcher.tsx';
import { DOCS_URL, GETPAID_URL } from '../lib/links.ts';
import type { Locale } from '../intl/index.ts';

export function Header({
  locale,
  onLocaleChange,
}: {
  locale: Locale;
  onLocaleChange: (next: Locale) => void;
}) {
  const intl = useIntl();
  const t = (id: string) => intl.formatMessage({ id });

  return (
    <header className="sticky top-0 z-10 border-b border-[var(--color-beige-300)] bg-[var(--color-beige-50)]/90 backdrop-blur">
      <div className="mx-auto flex max-w-5xl items-center justify-between gap-3 px-4 py-3 sm:gap-4">
        <Link to="/" aria-label={t('nav.home')} className="flex min-w-0 shrink overflow-hidden">
          <Logo size={24} />
        </Link>

        <nav className="flex shrink-0 items-center gap-2 sm:gap-4">
          <Link
            to="/pricing"
            className="hidden px-2 text-sm font-medium text-[var(--color-navy-800)] hover:text-[var(--color-navy-950)] sm:inline"
          >
            {t('nav.pricing')}
          </Link>
          <Link
            to="/integrators"
            className="hidden px-2 text-sm font-medium text-[var(--color-navy-800)] hover:text-[var(--color-navy-950)] sm:inline"
          >
            {t('nav.integrators')}
          </Link>
          <Link
            to="/affiliates"
            className="hidden px-2 text-sm font-medium text-[var(--color-navy-800)] hover:text-[var(--color-navy-950)] sm:inline"
          >
            {t('nav.affiliates')}
          </Link>
          <a
            href={DOCS_URL}
            className="hidden px-2 text-sm font-medium text-[var(--color-navy-800)] hover:text-[var(--color-navy-950)] sm:inline"
          >
            {t('nav.docs')}
          </a>
          <LanguageSwitcher locale={locale} onChange={onLocaleChange} label={t('locale.label')} />
          <Button asChild size="sm">
            <a href={GETPAID_URL}>{t('nav.getPaidNow')}</a>
          </Button>
        </nav>
      </div>
    </header>
  );
}
